type Ref<N = any> =
	| React.MutableRefObject<N>
	| React.Ref<N>
	| React.RefObject<N>
	| React.LegacyRef<N>
	// | ((node: N | null) => void)
	| undefined
	| null;

/**
 * When multiple refs would like to share the same node but cannot be used in a hook format.
 * Like when utilizing a ref from the children callback of `InfiniteLoader`
   @example
   <div ref={combineRefs<NodeType>(ref, anotherRef, andAnotherRef)}
 */
export function combineRefs<N = any>(...refs: Ref<N>[]) {
	return (node: N) => {
		refs.forEach((ref) => {
			if (!ref) return;
			typeof ref === 'function'
				? ref(node)
				: ((ref as React.MutableRefObject<N>).current = node);
		});
	};
}
